/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

function base64Url(value: string): string {
  return btoa(value).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

/**
 * Builds a JWT-shaped bearer token for local dev (mock mode). The backend does NOT verify the
 * signature; DisclaimerUtil.extractNodeFromHeaders simply base64url-decodes the middle segment to
 * read user claims (gmuniqueidentifier -> user id). The header and signature segments are
 * placeholders so the token still splits into the required three parts.
 */
export function buildMockToken(gmin: string): string {
  const header = base64Url(JSON.stringify({ alg: 'none', typ: 'JWT' }));
  const payload = base64Url(
    JSON.stringify({
      gmuniqueidentifier: gmin,
      givenName: 'Dev',
      surname: 'User',
      mail: 'dev@localhost',
      country: 'US',
    }),
  );
  return `${header}.${payload}.mock-signature`;
}
